import {CircularProgress} from "@mui/material";

export default function SystemAppContentLoader() {
    // Used through the app to display loader in single
    // screen

    // BUILD
    return (
        <div className={"animate-appear flex justify-center pt-[80px]"}>
            <CircularProgress size={"48px"} style={{'color' : 'white'}} />
        </div>
    );
}
